import { Map, List } from 'immutable'

const { videojs } = global
const Component = videojs.getComponent('Component')

/**
 * @class
 * @extends Component
 */
// eslint-disable-next-line import/prefer-default-export
export class VideoChaptersMenuLanguageColumn extends Component {
  /**
   * @param {Player|Object} player
   * @returns {void}
   */
  constructor (player, options) {
    super(player, { ...options, className: 'vjs-chapters-menu-language-column' })

    // Only add language list once
    if (!this.children().length) {
      this.#addLanguageList()
    }
  }

  /**
   * @returns {void}
   */
  #addLanguageList () {
    const plugin = this.player().VideoChapters()
    const chapters = plugin.getChapters()
    const currentLanguage = plugin.getCurrentLanguage()

    // Handle different possible data structures
    let availableLanguages = List()
    if (Map.isMap(chapters)) {
      availableLanguages = chapters.keySeq()
    } else if (chapters && typeof chapters === 'object') {
      // If chapters is a plain object, get the keys
      availableLanguages = List(Object.keys(chapters))
    }

    // Add title
    const titleDiv = document.createElement('div')
    titleDiv.className = 'vjs-sub-menu-title'
    titleDiv.style.cssText = `
      font-weight: bold;
      color: #fff;
      padding: 8px 12px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    `
    titleDiv.textContent = 'Language'
    this.el().appendChild(titleDiv)

    // Add language options
    availableLanguages.forEach((language) => {
      const languageDiv = document.createElement('div')
      languageDiv.className = 'vjs-menu-item'
      languageDiv.style.cssText = `
        color: #fff !important;
        background-color: ${language === currentLanguage ? '#01b4b4' : 'transparent'};
        padding: 8px 12px;
        cursor: pointer;
        border: none;
        text-align: left;
        width: 100%;
        font-size: 14px;
        line-height: 1.4;
      `
      languageDiv.textContent = this.getLanguageLabel(language)

      languageDiv.addEventListener('click', () => {
        plugin.setCurrentLanguage(language)

        // Dispatch a custom event to refresh the chapters
        const event2 = new CustomEvent('languageChanged', { detail: { language } })
        this.player().el().dispatchEvent(event2)

        // Update the language column to show the new selection
        this.el().innerHTML = ''
        this.#addLanguageList()
      })

      this.el().appendChild(languageDiv)
    })
  }

  /**
   * Get language label for display
   * @param {string} language - Language code
   * @returns {string} Language label
   */
  // eslint-disable-next-line class-methods-use-this
  getLanguageLabel (language) {
    const labels = {
      en: 'English',
      es: 'Español',
      fr: 'Français',
      de: 'Deutsch',
    }
    return labels[language] || language
  }
}
